import { useQuery } from '@tanstack/react-query'
import { JsonRpcError } from '~/types'
import { PayoutWalletBalance } from '../types'

export const usePayoutWalletBalance = ({ currency }) => {
    return useQuery<PayoutWalletBalance, JsonRpcError>({
        queryKey: ['payout_wallet_balance', currency],
        queryFn: async () => {
            const res = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'bank.payout_wallet.balance',
                    params: { currency },
                }),
            })
            const data = await res.json()
            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        retry: false,
    })
}
